// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-panel button.expand-button {\n  font-size: 1em;\n  display: inline-block;\n}\n.expand-panel .panel {\n  display: none;\n}\n.expand-panel.open .panel {\n  display: block;\n  padding-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
